import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import styles from '../../ProgressSlide.module.scss';
const RenderDate = t0 => {
  const $ = _c(21);
  const {
    general,
    day,
    month,
    year,
    isMobile
  } = t0;
  const t1 = general && isMobile ? styles.generalDate : "";
  let t2;
  if ($[0] !== t1) {
    t2 = cn(styles.date, t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== general || $[3] !== isMobile) {
    t3 = (!general || isMobile) && <figure className={styles.date__line} />;
    $[2] = general;
    $[3] = isMobile;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== day) {
    t4 = <p className={styles.date__day}>{day}</p>;
    $[5] = day;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== month) {
    t5 = <span className={styles.date__month}>{month} </span>;
    $[7] = month;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== year) {
    t6 = <span className={styles.date__year}>{year}</span>;
    $[9] = year;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <p>{t5}{t6}</p>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t7) {
    t8 = <div className={styles.date__inner}>{t4}{t7}</div>;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t2 || $[18] !== t3 || $[19] !== t8) {
    t9 = <div className={t2}>{t3}{t8}</div>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
export default RenderDate;